import { Show } from 'solid-js';
import { slotCentreMm, BADGE_DIAMETER_MM, FULL_DIAMETER_MM } from '../core/geometry';
import type { Slot } from '../types';

export function SlotElement(props: {
  slot: Slot;
  highlight: boolean;
  onClick?: (id: number) => void;
}) {
  const centre = () => slotCentreMm(props.slot.id);
  const D = () => (props.slot.fitTarget === 'centre' ? BADGE_DIAMETER_MM : FULL_DIAMETER_MM);
  const clipId = () => `clip-slot-${props.slot.id}`;

  return (
    <g
      class="slot"
      classList={{ 'slot--clickable': props.onClick != null }}
      data-slot-id={props.slot.id}
      transform={`translate(${centre().x}, ${centre().y})`}
      onClick={() => props.onClick?.(props.slot.id)}
    >
      <Show when={props.slot.image}>
        {img => (
          <>
            <defs>
              <clipPath id={clipId()}>
                <circle r={D() / 2} />
              </clipPath>
            </defs>
            <image
              href={img().objectUrl}
              x={-D() / 2}
              y={-D() / 2}
              width={D()}
              height={D()}
              preserveAspectRatio="xMidYMid slice"
              clip-path={`url(#${clipId()})`}
            />
          </>
        )}
      </Show>
      <circle
        class="cut-line"
        r={FULL_DIAMETER_MM / 2}
        fill="none"
        stroke="#d33"
        stroke-width="0.15"
        stroke-dasharray="0.8 0.4"
      />
      {/* Invisible larger hit area for easier tapping on mobile */}
      <Show when={props.onClick != null}>
        <circle
          r={FULL_DIAMETER_MM / 2 + 1}
          fill="transparent"
          pointer-events="all"
        />
      </Show>
      <Show when={props.highlight}>
        <circle
          class="highlight"
          r={FULL_DIAMETER_MM / 2 + 0.5}
          fill="none"
          stroke="#3aa86d"
          stroke-width="0.3"
        />
      </Show>
    </g>
  );
}
